import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  FormHelperText,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { browserName } from "react-device-detect";
import CaptchaTest from "../Components copy/Captcha/CaptchaTest";
import {
  sendMobileNoAPICall,
  locationCheckAPICall,
  AdminLoginToClientAccountAPICall,
} from "../shared copy/APICalls";
import { IAdminLogin, IMobile } from "../shared copy/dtos";
import routesData from "../shared copy/routes.json";
import SignupStyles from "../pages copy/Styles/SignUp.module.scss";
import SignUpImage from "../Components copy/assets/Images/signupimage.svg";
import SnackBar from "../Components copy/SnackBars/SnackBar";
import ErrorSnackBar from "../Components copy/SnackBars/ErrorSnackBar";
import Page1 from "./LandingPageScreens/Page1/Page1";
import Page2 from "./LandingPageScreens/Page2/Page2";
import Page3 from "./LandingPageScreens/Page3/Page3";
import mobilevideo from "../Components copy/assets/Images/mobilevideolatest.mp4";

import Header from "./Header";
import Footer from "../Components copy/Footer/Footer";

export default function SignupPage() {
  const navigate = useNavigate();

  const [message, setMessage] = useState("");
  const [loadingcontent, setloadingcontent] = useState(true);

  const navigationData: any = routesData;

  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());
  const source = Object.keys(params)[0];
  const id = (params.c && params.c) || (params.p && params.p);

  //  console.log(Object.keys(params)[0]);

  const client_id = params.client_id;
  const user_id = params.user_id;

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    setTimeout(() => {
      setloadingcontent(false);
    }, 1000);
  }, []);

  useEffect(() => {
    if (client_id && client_id) {
      let obj: IAdminLogin = {
        client_id: client_id,
        user_id: user_id,
      };

      AdminLoginToClientAccountAPICall(obj)
        .then((response: any) => {
          const responseData = response.data;
          // console.log("responseData", responseData);
          sessionStorage.setItem(
            "access-token",
            responseData.data.access_token
          );
          if (
            responseData.data.stage &&
            navigationData.hasOwnProperty(responseData.data.stage)
          ) {
            if (responseData.data.stage === "your_details") {
              navigate(navigationData[responseData.data.stage], {
                state: { validationID: undefined },
              });
            } else {
              navigate(navigationData[responseData.data.stage]);
            }
          }
        })
        .catch((error: any) => {
          setMessage(error.response.data.error.message);
          setTimeout(() => {
            setMessage("");
          }, 5000);
        });
    }
  }, [client_id, user_id]);

  return (
    <>
      {loadingcontent && (
        <div className={SignupStyles.loaderSection}>
          <span className={SignupStyles.loader}></span>
        </div>
      )}

      <div className={SignupStyles.wrapper} style={{visibility:loadingcontent?"hidden":"visible"}}>
        <div className={SignupStyles.leftContainer}>
          <video
            autoPlay={true}
            loop
            muted
            playsInline
            className={SignupStyles.video}
          >
            <source
              src="https://firstock-common.s3.ap-south-1.amazonaws.com/projects/partnersignup/partnerherodesktop.mp4"
              type="video/mp4"
            />
          </video>
          <video
            autoPlay={true}
            loop
            muted
            playsInline
            className={SignupStyles.videoMobileView}
          >
            <source
              src="https://firstock-common.s3.ap-south-1.amazonaws.com/projects/partnersignup/partnerheromobile.mp4"
              type="video/mp4"
              // src={mobilevideo}
            />
          </video>
        </div>
        <div className={SignupStyles.RightContainer}>
          <div className={SignupStyles.headerSection}>
            <p className={SignupStyles.signup}>Expand Your Horizons. </p>
            <p className={SignupStyles.signup}>
              {" "}
              Grow with <span style={{ color: "#007585" }}>Firstock</span>{" "}
            </p>
            <p className={SignupStyles.subText}>
              Channel the future of{" "}
              <span style={{ fontWeight: 700 }}>investing</span>. With each
              lead, we don't just grow funds – we{" "}
              <span style={{ fontWeight: 700 }}>foster futures</span>. Let's{" "}
              <span style={{ fontWeight: 700 }}>co-create success</span>.
            </p>
            <div className={SignupStyles.buttonSection}>
              <LoadingButton
                variant="contained"
                type="submit"
                id="signupContinueButton"
                className={SignupStyles.button}
                onClick={() => {
                  navigate("/mobile");
                }}
                sx={{
                  borderRadius: "5px",
                  background: "#007585",
                  "&:hover": {
                    background: "#007585",
                  },
                }}
              >
                Get Started
              </LoadingButton>
            </div>
          </div>
        </div>
      </div>

      <Page1 />
      <Page2 />
      <Page3 />
      <Footer />
    </>
  );
}
